<template>
  <div class="contents-list-page">
    <div class="action-buttons">
      <AddContentButton color="#C32AA3" @click="onClickAddContests"
        >Add Contest</AddContentButton
      >
    </div>
    <div class="row">
      <perfect-scrollbar class="col-md-8">
        <ContentsList
          ref="contentsList"
          @edit="onEditContent"
          :types="['campaign']"
          :emptyText="emptyText"
        />
      </perfect-scrollbar>
      <perfect-scrollbar class="col-md-4">
        <FilterList>
          <template v-slot:header>Contest Options</template>
          <template v-slot:btn>
            <div class="mb-2">
              <button
                class="btn btn-secondary rounded mr-2"
                @click="onClickChangeStatus('PUBLISH')"
              >
                <i class="far fa-eye"></i>
                PUBLISH
              </button>
              <button
                class="btn btn-secondary rounded"
                @click="onClickChangeStatus('UNPUBLISH')"
              >
                <i class="far fa-eye-slash"></i>
                UNPUBLISH
              </button>
            </div>
            <div class="button-add">
              <button
                class="btn btn-secondary btn-block rounded"
                @click="onClickAddContests()"
              >
                ADD CONTEST
              </button>
              <button
                class="btn btn-secondary btn-block rounded"
                @click="onClickJoinContest('experience')"
              >
                JOIN CONTEST
              </button>
            </div>
          </template>
          <template v-slot:headerfilter>Filter Listings</template>

          <template v-slot:filter>
            <div class>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search content"
                  aria-label="Search content"
                  aria-describedby="basic-addon2"
                  v-model="search"
                />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 py-1">
                <button class="btn btn-status btn-block">Published</button>
              </div>
              <div class="col-md-4 py-1">
                <button class="btn btn-status btn-block">Unpublished</button>
              </div>
              <div class="col-md-4 py-1">
                <button class="btn btn-status btn-block">Incomplete</button>
              </div>
              <div class="col-md-4 py-1">
                <button class="btn btn-status btn-block">Most Likes</button>
              </div>
              <div class="col-md-4 py-1">
                <button class="btn btn-status btn-block">Jury Picks</button>
              </div>
            </div>
            <div class="mt-2">
              <select v-model="sort" class="form-control">
                <option value="TITLE">Sort by title</option>
                <option value="CREATED_AT">Sort by date posted</option>
              </select>
            </div>
            <div class>
              <div class="row">
                <div class="col-md-6">
                  <button class="btn btn-apply btn-block" @click="onSearch">
                    <span></span>
                    <span>APPLY</span>
                    <i class="fas fa-check"></i>
                  </button>
                </div>
                <div class="col-md-6">
                  <button class="btn btn-reset btn-block" @click="onReset">
                    <span></span>
                    <span>RESET FILTERS</span>
                    <i class="fas fa-redo"></i>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </FilterList>
      </perfect-scrollbar>
    </div>

    <transition name="fade">
      <ContestForm
        v-if="showContestForm"
        @close="onCloseContest"
        :content="content"
      />
    </transition>
    <transition name="fade">
      <ContestForm
        v-if="showJoinContest"
        @close="onCloseJoinContest"
        :content="content"
      />
    </transition>
  </div>
</template>

<script>
import AddContentButton from "@/components/AddContentButton";
import ContestForm from "@/components/ContestForm";
import ContentsList from "@/components/ContentsList";
import FilterList from "@/components/Filter";
export default {
  components: {
    AddContentButton,
    ContestForm,
    ContentsList,
    FilterList,
  },
  data() {
    return {
      showContestForm: false,
      showJoinContest: false,
      content: null,
      emptyText:
        "This account has no contest yet. Please press the ADD button above",
      search: "",
      types: [],
      sort: "CREATED_AT",
      btn: {
        experience: false,
        tour: false,
        event: false,
        story: false,
      },
    };
  },
  methods: {
    onClickAddContests() {
      this.showContestForm = true;
    },
    onAdd(e){
      this.showJoinContest = true;
    },
    onCloseContest() {
      this.showContestForm = false;
      this.reload();
    },
    onClickJoinContest() {
      this.$router.push('/contests/join') 
    },
    onCloseJoinContest() {
      this.showJoinContest = false;
      this.reload();
    },
    onSearch() {
      
    },
    onReset() {
      
    },
    reload() {
      this.content = null;
      this.$refs.contentsList.reload();
    },
    async onEditContent(id, type) {
      switch (type) {
        case "campaign":
          this.content = await this.$repo.contest.getContest(id);
          this.showContestForm = true;
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.contents-list-page {
  .ps {
    height: 85vh;
  }

  .add-content-button + .add-content-button {
    margin-left: 34px;
  }
}
</style>
